<template>
    <div class="post_home_div">
        <Posts></Posts>
    </div>
</template>

<script type="text/javascript">

import Posts from '@/components/posts_page/posts.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        Posts,
    },
    computed: {
        ...mapGetters({
            query_args: 'questions/router_args'
        })
    },

    methods: {
        ...mapActions({
            get_question_list: 'questions/change_question_list_information',
            get_related_stuff: 'questions/get_related_stuff',
            checkin: 'user/checkin'
        })
    },

    watch: {
        '$route': function () {
            this.get_question_list(this.query_args)
        }
    },

    mounted: function () {
        this.get_question_list(this.query_args)
        this.get_related_stuff()
        this.checkin({'method': 'GET'})
    }
}
</script>
<style type="text/css">
</style>
